import { AIFansSubscription } from './types/aifans-schema'

const ACTIVE_STATUSES = new Set(['active', 'reactivating'])

/** True when the user has an active/reactivating platform-wide Premium membership. */
export function hasActivePremium(subs: AIFansSubscription[] | undefined): boolean {
  return !!subs?.some((s) => s.scope === 'platform' && ACTIVE_STATUSES.has(s.status))
}

/** Character ids the user has an active per-character (à la carte VIP) sub for.
 *  Legacy subs have no `scope`, so anything not explicitly 'platform' counts as character. */
export function getVipCreatorIds(subs: AIFansSubscription[] | undefined): string[] {
  return (subs ?? [])
    .filter((s) => s.scope !== 'platform' && s.status === 'active' && !!s.characterId)
    .map((s) => s.characterId)
}
